import { tokens } from "shared/components/Spor";
import { FC } from "react";
import styled from "styled-components";
import {
  AssistanceEvent,
  AssistanceType,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/AssistanceEventGridItem/AssistanceType";

const ContentWrapper = styled.div`
  border-radius: ${tokens.default.size.spacing[1]};
  padding: ${tokens.default.size.spacing[2.5]};
  background-color: ${({ theme }) => theme.colorBackgroundTertiary};

  display: flex;
  flex-flow: row nowrap;
  gap: ${tokens.default.size.spacing[2]};
  justify-content: space-between;
  align-items: center;
`;

type CollapsedTrainItemProps = {
  assistanceEvent: AssistanceEvent;
};

export const CollapsedAssistanceItem: FC<CollapsedTrainItemProps> = ({
  assistanceEvent,
}) => (
  <ContentWrapper>
    <AssistanceType eventType={assistanceEvent.type} />
  </ContentWrapper>
);
